import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextProvider } from "./contextProvider/ContextProvider";
import { getConfiguratorId, getTheme } from "./config/runtimeConfig";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  const id = getConfiguratorId();
  const activeTheme = getTheme();
  document.body.classList.remove("theme-ped", "theme-bosch");
  document.body.classList.add(activeTheme);

  root.render(
    <React.StrictMode>
      <ContextProvider>
        <App wpId={id} />
      </ContextProvider>
    </React.StrictMode>
  );
}

// Keep reportWebVitals if you're using it
reportWebVitals();
